import { LoginPageContainer } from 'components/loginPage/LoginPageContainer';
import React from 'react';
import { LoadingImage } from 'ui-toolkit';

export interface IAuthLoginViewProps {}

export const LoginPageLoading: React.FC<IAuthLoginViewProps> = () => {
  return (
    <LoginPageContainer>
      <LoadingImage />
    </LoginPageContainer>
  );
};
